import { useMemo } from "react";

import { useLanguage } from "../../../../i18n/useLanguage";
import { OrderDetails } from "../../../../stores/slices/cartSlice";
import { useOrdersCriteriaParam } from "./CriteriaInput";

interface OrderDatePredicateHook {
  (): (item: OrderDetails) => boolean;
}

export const useOrdersCriteriaPredicate: OrderDatePredicateHook = () => {
  const [criteria] = useOrdersCriteriaParam();
  const [language] = useLanguage();
  const predicate = useMemo(
    () =>
      ({
        customerEmail,
        customerName,
        customerNotes,
        customerPhone,
        orderCreatedUserName,
        orderGrandTotal,
        orderId,
        orderStatusDescription,
      }: OrderDetails) => {
        const textRow: string[] = [
          customerEmail,
          customerName,
          customerNotes,
          customerPhone,
          orderCreatedUserName,
          orderGrandTotal,
          orderId,
          orderStatusDescription[language],
        ];
        return criteria.trim()
          ? textRow
              .join(" ")
              .toLowerCase()
              .includes(criteria.trim().toLowerCase())
          : true;
      },
    [criteria, language]
  );
  return predicate;
};
